// extracted by mini-css-extract-plugin
export var two = "styles-module--two--MrNDW";
export var hdg = "styles-module--hdg--2kT_3";
export var faqs = "styles-module--faqs--POAKR";
export var qaContainer = "styles-module--qaContainer--2vW1K";
export var hidden = "styles-module--hidden--PO1GV";